/* eslint semi:0 */
import { queryString } from '../../utils/window'
import { namespacedConsts } from '../../utils/object'
import { appDispatcher } from '../../application/AppDispatcher'

const CLASS_CONSTATNTS = namespacedConsts({
  USER_TOOLBAR: {
    ACTIONS: {
      FB_SDK_READY: true,
      FB_LOGIN: true,
      EXISTING_USER_AUTHENTICATED: true,
      NEW_USER_AUTHENTICATED: true,
      LOGOUT: true,
      AUTHENTICATION_FAILED: true,
      UNIMPERSONATE: true,
    },
  },
})

export const TYPES = CLASS_CONSTATNTS.USER_TOOLBAR.ACTIONS

export const fbSdkReady = () => {
  appDispatcher.dispatchAction.external({
    type: TYPES.FB_SDK_READY,
  })
}

export const fbLogin = (origin = 'UserToolbar') => {
  appDispatcher.dispatchAction.view({
    type: TYPES.FB_LOGIN,
    origin,
  })
}

export const authenticated = response => {
  let { EXISTING_USER_AUTHENTICATED, NEW_USER_AUTHENTICATED } = TYPES
  let actionType = response.existing ? EXISTING_USER_AUTHENTICATED : NEW_USER_AUTHENTICATED
  let userData = response.data
  let signupModalData = response.signup_modal_data
  if (queryString.forceNewUser) {
    actionType = NEW_USER_AUTHENTICATED
    signupModalData = {}
  }

  appDispatcher.dispatchAction.server({
    type: actionType,
    userData,
    authId: response.auth_id,
    signupModalData,
    dispatchToRedux: true,
    payload: userData,
  })
}

export const reauthenticated = response => {
  response.isReauthenticated = true
  authenticated(response)
}

export const logout = () => {
  appDispatcher.dispatchAction.view({
    type: TYPES.LOGOUT,
    dispatchToRedux: true,
  })
}

export const autnenticationFailed = response => {
  appDispatcher.dispatchAction.server({
    type: TYPES.AUTHENTICATION_FAILED,
    response,
  })
}

export const unimpersonate = response => {
  appDispatcher.dispatchAction.server({
    type: TYPES.UNIMPERSONATE,
    response,
  })
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/actions/userToolbarActions.js